
export const normalizeUser = (user) => {
  if (!user) return null;

  const accountType =
    user?.agentDetail?.accountType ||
    user?.role ||
    "guest";

  const roleName =
    user?.roleName ||
    user?.roleData?.name ||
    null;

  return {
    ...user,
    accountType,
    roleName,
    effectiveRole: roleName || accountType,
  };
};